import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

interface IGetThreadsInfoParams {
  messages: ChatMessage[];
  groupId: string;
}

export async function getThreadsInfo(params: IGetThreadsInfoParams): Promise<void | null> {
  return null;
}
